import React, { useEffect, useState } from "react";
import logo from "../../../assets/landingFeatures/explorer.png";
import { Button} from "antd";
import {

  MenuOutlined,
  CloseOutlined
} from "@ant-design/icons";

import "./jobListingPageHeader.scss";
import { useNavigate } from "react-router-dom";

export default function JobListingsPageHeader() {
  const navigate = useNavigate(); 

  // Scrolls to the top of the page when the component mounts
  useEffect(() => {

  }, []);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
  }, [])

  const handleSignin = () => {
    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });
  };


  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };
  return (
    <div className="jobListingpageheader-wrapper">
       <div className="jobListing-header"> 
          <div className="jobListing-header-logo" onClick={()=>navigate("/nujobs")}>
              <img className="jobListing-logo-img"src={logo} />
          </div>
          <div className="header-menu">
            <ul className="header-menu">
              <li >
                <a href="/nujobs">Jobs</a>
              </li>
              <li >
                <a href="/nujobswhoishiringnow">Who's Hiring</a>
              </li>    
              <li >
                <a href="/nujobsupcomingevents">Hiring Events</a>
              </li>                         
              <li>
                <a href="/nujobsemployerpage">For Employers</a>
              </li>      
              <li>
                <a href="/nujobscontact">Support</a>
              </li>                                                                   
            </ul>
          </div>
          <div
            className="jobListing-mobile-menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
          </div>   
               
          <div className="header-sign">
            <Button className="sign-button" onClick={() => handleSignin()}>
              Candidate Sign In
            </Button>
            <Button className="job-button" onClick={() => handlePostJobs()}>
              Employers Sign In
            </Button>                                     
          </div>          
       </div>
        {mobileMenuOpen && (
          <div className="jobListing-mobile-menu-dropdown">

            <a
              href="/nujobs"
              onClick={() => setMobileMenuOpen(false)}
            >
              Jobs
            </a>
            <a
              href="/nujobsemployerpage"
              onClick={() => setMobileMenuOpen(false)}
            >
              Employers
            </a>
            <a
              href="/nujobscontact"
              onClick={() => setMobileMenuOpen(false)}
            >
              Support
            </a>

          </div>
        )}        
    </div>
  );
}
